import {
  POST_IMPERSONATE,
  POST_IMPERSONATE_FAILED,
  POST_IMPERSONATE_SUCCESS,
} from "./actionTypes";

const initialState = {
  loader: false,
  impersonateSuccess: null,
  impersonateFailed: null,
};

const impersonateReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_IMPERSONATE:
      state = {
        ...state,
        loader: true,
        impersonateSuccess: null,
        impersonateFailed: null,
      };
      break;
    case POST_IMPERSONATE_SUCCESS:
      state = {
        ...state,
        loader: false,
        impersonateSuccess: action.payload,
        impersonateFailed: null,
      };
      break;
    case POST_IMPERSONATE_FAILED:
      state = {
        ...state,
        loader: false,
        impersonateSuccess: null,
        impersonateFailed: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};
export default impersonateReducer;
